import React from 'react';
const testimonials = [{
  initials: 'VR',
  name: 'Valentina R.',
  location: '📍 Buenos Aires | Mamá de Tomás, 4 años',
  quote: '"Compré un sábado a la tarde. Esa misma noche lo imprimí y al otro día mi hijo pasó 2 horas sentado coloreando sin pedirme el celular ni una sola vez. No lo podía creer. Vale cada peso."'
}, {
  initials: 'CM',
  name: 'Carolina M.',
  location: '📍 Córdoba | Mamá de Juanita, 5 años',
  quote: '"Mi hija era adicta al celu. Lloraba cada vez que se lo sacaba. Con el Plan de 7 Días del Método Desconectado™ en una semana ya elegía las fichas sola. Ahora me pide ella sentarse a hacer actividades."'
}, {
  initials: 'LS',
  name: 'Luciana S.',
  location: '📍 Rosario | Mamá de Mateo, 3 años',
  quote: '"Lo que más me gustó es que todo está ordenado por nivel. Empecé con las fichas más fáciles y fui subiendo. Mi hijo nunca se frustró porque siempre podía hacerlo. Eso es lo que lo enganchó."'
}, {
  initials: 'FT',
  name: 'Florencia T.',
  location: '📍 Mendoza | Mamá de Lucía, 6 años',
  quote: '"El tomo de inglés es una joya. Mi hija ya sabe los colores y los animales en inglés jugando. Su maestra me preguntó cómo lo aprendió y no lo podía creer cuando le dije que con fichas impresas en casa."'
}, {
  initials: 'RG',
  name: 'Romina G.',
  location: '📍 Tucumán | Mamá de Joaquín, 4 años',
  quote: '"Las fichas de tijera fueron un antes y un después. Mi hijo no podía agarrar bien la tijera y con las actividades del Tomo 3 en tres semanas ya recortaba solo. La maestra de jardín me felicitó."'
}, {
  initials: 'NS',
  name: 'Natalia B.',
  location: '📍 Santa Fe | Mamá de Emma, 5 años',
  quote: '"Lo que más me ayudó fue el Protocolo Anti-Berrinche. Antes era un drama sacarle el celu. Ahora aplico los 5 pasos y en dos minutos está sentada haciendo una ficha. Cambió la dinámica de toda la casa."'
}, {
  initials: 'PL',
  name: 'Paola L.',
  location: '📍 Neuquén | Mamá de Santiago, 3 años',
  quote: '"Siempre me sentí culpable por darle el celu. Desde que tengo el Megapack esa culpa desapareció. Sé que le estoy dando algo que lo estimula de verdad. Y él está más contento que nunca."'
}];
export function Testimonials() {
  return <section className="w-full px-4 py-10 text-gray-900 text-base leading-6" style={{
    backgroundColor: 'rgb(248, 250, 252)',
    fontFamily: '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, sans-serif'
  }} data-id="element-320">
      <div className="mx-auto max-w-4xl" data-id="element-321">

        {/* TÍTULO */}
        <h2 className="text-3xl font-black text-center leading-10 text-gray-900 m-0 mb-2" data-id="element-322">
          Lo que dicen las mamás que ya lo usan:
        </h2>
        <p className="text-center text-sm text-gray-600 m-0 mb-8" data-id="element-323">
          +1.200 familias de todo el país ya recuperaron sus tardes con este sistema.
        </p>

        {/* GRID DE TESTIMONIOS */}
        <div className="grid grid-cols-1 md:grid-cols-2 gap-4" data-id="element-324">
          {testimonials.map((t, i) => <div key={i} className="bg-white rounded-xl p-5 shadow-sm border border-orange-100 flex flex-col gap-3" data-id="element-325">
              {/* AVATAR + NOMBRE */}
              <div className="flex items-center gap-3" data-id="element-326">
                <div className="w-10 h-10 rounded-full bg-orange-500 text-white flex items-center justify-center font-bold text-sm shrink-0" data-id="element-327">
                  {t.initials}
                </div>
                <div data-id="element-328">
                  <p className="font-bold text-gray-900 m-0 text-sm" data-id="element-329">
                    {t.name}
                  </p>
                  <p className="text-gray-500 m-0 text-xs" data-id="element-330">{t.location}</p>
                </div>
              </div>

              {/* ESTRELLAS */}
              <div className="text-xs text-orange-400" data-id="element-331">
                ⭐⭐⭐⭐⭐
              </div>

              {/* QUOTE */}
              <p className="text-gray-700 m-0 text-sm italic leading-relaxed" data-id="element-332">
                {t.quote}
              </p>
            </div>)}
        </div>

      </div>
    </section>;
}